import { render, staticRenderFns } from "./JsonDrawer.vue?vue&type=template&id=33fe83dc&scoped=true&"
import script from "./JsonDrawer.vue?vue&type=script&lang=js&"
export * from "./JsonDrawer.vue?vue&type=script&lang=js&"
import style0 from "./JsonDrawer.vue?vue&type=style&index=0&id=33fe83dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe83dc",
  null
  
)

export default component.exports